export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const money = (v, c = 'INR') =>
  (v == null ? '—' : `${c === 'INR' ? '₹' : ''}${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`);
export const pct = (v, digits = 0) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);

// The owner of each action, in the seller's words rather than the sub-feature's.
export const OWNER_LABEL = {
  revert: 'Put back', stock: 'Stock', event: 'Event', ceiling: 'Monthly budget',
  reallocate: 'Move', cut: 'Cap loss', rescue: 'Raise', manual: 'You changed it',
};
export const ENV_CLASS = {
  over: 'env_over', under: 'env_under', 'on track': 'env_ontrack',
  'no budget set': 'env_under',
};
